module.exports = __webpack_public_path__ + "fonts/Raleway-Medium.2ec85574.ttf";